// extracted by mini-css-extract-plugin
export default {"checkBoxContainer":"CheckBox_checkBoxContainer__KWv+R","checkmark":"CheckBox_checkmark__HMnlC"};